export const Create = () => import("./Create.vue");
export const Details = () => import("./Details.vue");
export const Edit = () => import("./Edit.vue");
export const List = () => import("./List.vue");
